export default "icons-digital-print"